import LegalPageLayout from '@/components/feature/LegalPageLayout';

export default function DeliveryPage() {
  return (
    <LegalPageLayout title="Teslimat / Hizmet Süreci">
      <h4>1. Genel Süreç</h4>
      <p>Atak Sistem Enerji olarak, ürün ve hizmetlerimizin teslimat ve kurulum sürecini şeffaf ve planlı bir şekilde yürütmekteyiz.</p>

      <h4>2. Keşif ve İhtiyaç Analizi</h4>
      <p>Hizmet talebiniz alındıktan sonra bölgeniz, yaşam alanınız ve mevcut sisteminiz değerlendirilir. Gerekli durumlarda yerinde keşif planlaması yapılabilir.</p>

      <h4>3. Sistem Seçimi ve Teklif</h4>
      <p>İhtiyaç analizi sonrası, yaşam alanınıza ve kullanım beklentinize uygun sistem belirlenir. Seçilen sisteme göre fiyat teklifi ve kurulum planı hazırlanarak tarafınıza sunulur.</p>

      <h4>4. Sipariş Onayı ve Planlama</h4>
      <p>Teklifin onaylanmasının ardından ürün tedarik süreci başlatılır. Kurulum tarihi, karşılıklı mutabakat ile belirlenir.</p>

      <h4>5. Kurulum ve Teslimat</h4>
      <p>Belirlenen tarihte profesyonel ekibimiz tarafından kurulum gerçekleştirilir. Kurulum sonrası sistem çalışması test edilir ve kullanım hakkında bilgilendirme yapılır.</p>

      <h4>6. Kurulum Sonrası Destek</h4>
      <p>Kurulum sonrası olası sorularınız için WhatsApp veya telefon üzerinden destek ekibimize ulaşabilirsiniz.</p>

      <h4>7. Teslimat Süresi</h4>
      <p>Teslimat ve kurulum süresi; seçilen sisteme, bölgeye ve iş yoğunluğuna göre değişiklik gösterebilir. Kesin süre sipariş onayında tarafınıza bildirilecektir.</p>
    </LegalPageLayout>
  );
}